import { Component, HostListener } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Idle } from '@ng-idle/core';
import { idleActivityInterrupts } from 'src/app/core/session-signout';
import { AutoLogoutDialogComponent } from './Dialogs/auto-logout-dialog/auto-logout-dialog.component';
import { CrudService } from './services/crud.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Keepalive } from '@ng-idle/keepalive';
import { Router, NavigationEnd } from '@angular/router';
import { clearAllSavedDateRanges } from 'src/app/shared/components/date-range-filter/date-range-memory';
import { sessionEmail } from 'src/app/core/session-email';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})


export class AppComponent {
  title = 'front-osmos';

  defaultMerchantCountry: any;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  viewData = false;
  url: any
  addEditDialogRef: any;
  subscriptions: Subscription[] = [];
  timeoutEndTime: number;
  // Wall-clock timestamp of the last user activity. @ng-idle counts idle time with JS
  // timers, which browsers throttle/pause while a tab is backgrounded or the machine
  // sleeps — so a long absence may never trip its timeout. We compare against this on
  // resume to force a logout when real elapsed time exceeds the idle window.
  lastActivityTime: number = Date.now();
  // idle limit (1h) + warning countdown (60s) in ms — see idleApp().
  private readonly IDLE_LIMIT_MS = (3600 + 60) * 1000;
  private idleCheckTimer: any;
  constructor(private spinner: NgxSpinnerService,
    private translateService: TranslateService,
    private idle: Idle,
    private _gService: CrudService,
    private keepalive: Keepalive,
    public dialog: MatDialog,
    private router: Router) {
    // const userData = localStorage.getItem('loginUserValue') && JSON.parse(localStorage.getItem('loginUserValue'));
    // translateService.use(userData?.languages?.locale || 'en');
  }
  ngOnInit() {
    this.spinner.show();
    let strings = window.location.href.split(window.location.host);
    this.url = strings[strings.length - 1];
    if (this.url === '/dash/mail-box/inbox/1' && this.spinner.show()) {
      this.title = 'Loading Your emails...'
      this.viewData = true
    } else {
      !this.viewData
    }

    this.checkIframeAndEcodeContext();

    const routerSub = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.checkIframeAndEcodeContext(event.urlAfterRedirects || event.url);
    });
    this.subscriptions.push(routerSub);

    if(localStorage.getItem('loginUserValue')) {
        this.idleApp()
    }
  }

  private checkIframeAndEcodeContext(currentUrl?: string) {
    let isInIframe = false;
    try {
      isInIframe = window.self !== window.top;
    } catch (e) {
      isInIframe = true;
    }
    const path = currentUrl || (window.location.pathname || '') + (window.location.search || '') + (window.location.hash || '');
    const isPublicQuoteRoute = /e-quote|equote|quote-form-embed|lead-form-embed|ecode|\/invoice\/|quote-pdf-view|\/payment\//i.test(path);

    if (isInIframe || isPublicQuoteRoute) {
      document.documentElement.classList.add('in-equote-iframe');
      document.body.classList.add('in-equote-iframe');
      const chatbotElems = document.querySelectorAll(
        '#support-machine-widget, #lexiBotButton, .osmos-support-fab, .osmos-support-panel, [id*="support-machine"], [id*="support-widget"], [id*="lexiBot"], #sm-widget-root'
      );
      chatbotElems.forEach(el => (el as HTMLElement).style.setProperty('display', 'none', 'important'));
    } else {
      document.documentElement.classList.remove('in-equote-iframe');
      document.body.classList.remove('in-equote-iframe');
    }
  }

  ngOnDestroy(){
    // prevent memory leak when component destroyed
    this.subscriptions.forEach(s => s.unsubscribe());
    if (this.idleCheckTimer) { clearInterval(this.idleCheckTimer); }
  }

  // Dark-Theme //
  isDarkTheme = false;
  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme;
  }

  idleApp() {
    // sets an idle timeout of 5 seconds, for testing purposes.
    this.idle.setIdle(3600);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    this.idle.setTimeout(60);
    // Clicks, typing, wheel/touch and page scroll all count as activity (card #364).
    this.idle.setInterrupts(idleActivityInterrupts());

    this.idle.onIdleEnd.subscribe(() => console.log('No longer idle.'));
    // Mirror ng-idle's activity resets onto the wall-clock timestamp used on resume.
    this.idle.onInterrupt.subscribe(() => { this.lastActivityTime = Date.now(); });
    this.idle.onTimeout.subscribe(() => {
      this.dialog.closeAll();
      this.logout();
    });
    this.idle.onIdleStart.subscribe(() => {
      this.openDialog();
    });
    this.idle.onTimeoutWarning.subscribe((countdown) => console.log('You will time out in ' + countdown + ' seconds!'));

    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);

    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

    // Wall-clock safety net: even if visibility/focus events don't fire on resume (e.g.
    // the machine wakes with the tab still focused), this periodic check forces a logout
    // once real elapsed inactivity exceeds the idle window. The timer itself is paused
    // during sleep and resumes on wake, so its next tick catches the overdue session.
    if (this.idleCheckTimer) { clearInterval(this.idleCheckTimer); }
    this.idleCheckTimer = setInterval(() => {
      if (localStorage.getItem('loginUserValue') && (Date.now() - this.lastActivityTime) >= this.IDLE_LIMIT_MS) {
        this.dialog.closeAll();
        this.logout();
      }
    }, 60 * 1000);

    this.reset();
  }

  openDialog(): void {
    this.idle.clearInterrupts();
    this.timeoutEndTime = Date.now() + (60 * 1000);
    this.addEditDialogRef = this.dialog.open(
      AutoLogoutDialogComponent,
      { disableClose: true, width: '550px', height: '250px',panelClass: 'my-dialog-panel', data: { timeout: 60 } }
    );
    this.addEditDialogRef.afterClosed().subscribe((action: any) => {
      this.timeoutEndTime = null;
      if (action) {
        if (action === 'connected') {
          this.idle.setInterrupts(idleActivityInterrupts());
          this.reset();
        }
        if (action === 'logout') {
          this.idle.setInterrupts(idleActivityInterrupts());
          this.logout();
        }
      }
    });
  }

  @HostListener('document:visibilitychange')
  @HostListener('window:focus')
  onVisibilityChange() {
    // Only act when logged in and the tab is actually in the foreground again.
    if (!localStorage.getItem('loginUserValue') || document.visibilityState !== 'visible') {
      return;
    }
    // visibilitychange/focus fire before any click interrupt resets lastActivityTime, so
    // this reflects the real time the user was away even if ng-idle's timer was paused
    // while the tab was backgrounded or the machine was asleep.
    const inactiveFor = Date.now() - this.lastActivityTime;
    const warningExpired = !!this.timeoutEndTime && Date.now() >= this.timeoutEndTime;
    if (warningExpired || inactiveFor >= this.IDLE_LIMIT_MS) {
      this.dialog.closeAll();
      this.logout();
    }
  }

  reset() {
    this.lastActivityTime = Date.now();
    this.idle.watch();
  }

  async logout() {
    const payload = {
      id: localStorage.getItem('userId'),
      email: sessionEmail(), // Card #381: same key the session was created under
      merchant_id: localStorage.getItem('merchant_id'),
      device_id: localStorage.getItem('deviceLoginId')
    }
    await this._removeSession(payload)
    localStorage.removeItem('reminderList');
    localStorage.removeItem('merchant_id');
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('fname');
    localStorage.removeItem('lname');
    localStorage.removeItem('email');
    localStorage.removeItem('profile_pic');
    localStorage.removeItem('create-session');
    localStorage.removeItem('redirect-merchant');
    localStorage.removeItem('user_merchants');
    localStorage.removeItem('deviceLoginId');
    localStorage.removeItem('loginUserValue');
    // Card #269: remembered report date ranges never outlive the session.
    clearAllSavedDateRanges();
    localStorage.removeItem('osmos_access_level');
    localStorage.removeItem('permission');
    localStorage.removeItem('role');
    localStorage.removeItem('accessId');
    localStorage.removeItem('country_list');
    // Quote-listing saved sort preferences
    localStorage.removeItem('quoteListingSortField');
    localStorage.removeItem('quoteListingSortOrder');
    localStorage.removeItem('quoteListingCustomSort');
    localStorage.removeItem('quoteListingSortColumn');
    this.translateService.use('en');
    window.location.reload();
  }

  private _removeSession(body) {
    return this._gService.postUserManagement(`merchantuser/removeusersession`, body)
      .toPromise()
      .catch(() => {});
  }
}
